import { ArticleStatus } from './article-status.enum';
var ArticleTranslationBuilder = /** @class */ (function () {
    function ArticleTranslationBuilder() {
        this.articleTranslation = {
            url: '',
            locale: '',
            status: ArticleStatus.DRAFT,
            title: ''
        };
    }
    ArticleTranslationBuilder.prototype.withUrl = function (url) {
        this.articleTranslation.url = url;
        return this;
    };
    ArticleTranslationBuilder.prototype.withTitle = function (title) {
        this.articleTranslation.title = title;
        return this;
    };
    ArticleTranslationBuilder.prototype.withLocale = function (locale) {
        this.articleTranslation.locale = locale;
        return this;
    };
    ArticleTranslationBuilder.prototype.withStatus = function (status) {
        this.articleTranslation.status = status;
        return this;
    };
    ArticleTranslationBuilder.prototype.build = function () {
        return this.articleTranslation;
    };
    return ArticleTranslationBuilder;
}());
export { ArticleTranslationBuilder };
//# sourceMappingURL=article-translation.builder.js.map